import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { UserGuard } from './guards/accept.guard';

const routes: Routes = [
	{
		path: 'scan',
		loadChildren: () => import('./pages/scan/scan.module').then((m) => m.ScanPageModule)
	},
	{
		path: 'start',
		loadChildren: () => import('./pages/start/start.module').then((m) => m.StartPageModule)
	},
	{
		path: 'terms',
		loadChildren: () => import('./pages/terms/terms.module').then((m) => m.TermsPageModule)
	},
	{
		path: 'welcome',
		loadChildren: () => import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule)
	},
	{
		path: '',
		loadChildren: () => import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule),
		canActivate: [UserGuard]
	},
	{
		path: 'home',
		loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule)
	},
	{
		path: 'activity',
		loadChildren: () => import('./pages/activity/activity.module').then((m) => m.ActivityPageModule)
	}
];
@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
